//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngRadioButton', srsngRadioButton);

    function srsngRadioButton($compile) {

        return {
            restrict: 'A',
            scope: true,
            link: link
        };

        function link(scope, element, attrs) {
            element.hide();
            let el = $compile(`<span class="radio-button-icon" ng-include="'container/ui/assets/img/icons/system-icons-16x16/system-ic-radio-button' + (modelVal == val ? '-checked' : '') + '-16x16.svg'"</span>`)(scope);
            element.after(el);

            scope.$watch(attrs.ngModel, newValue => {
                scope.modelVal = newValue;
            });

            scope.val = attrs.value;
        }
    }

})();

